function initGlobalPopups() {
    const popups = document.querySelectorAll('.global-popup-wrapper dialog');
    popups.forEach(popup => {
        let delay = Number(popup.dataset.delay) || 5 //Defaults to 5 in case the unexpected happens

        //Close button functionality
        const closeButtons = popup.querySelectorAll('.close-btn');
        if (closeButtons && closeButtons.length > 0) {
            closeButtons.forEach(closeButton => {
                closeButton.addEventListener('click', () => {
                    popup.close();
                });
            });
        }

        //Initialize redirector if present

        initPopupRedirector(popup);

        //Display the popup if should

        let shouldShow = shouldShowPopup(popup);

        if (!shouldShow) return;

        setTimeout(() => {
            popup.showModal();
        }, delay * 1000); //Convert to milliseconds

        //Handle popup close
        popup.addEventListener('close', () => {
            setPopupActivity(popup);
        })
    });
}

function initPopupRedirector(popup) {
    const redirector = popup.querySelector('.redirector-wrapper');
    if (!redirector) return;

    const select = redirector.querySelector('select');
    const button = redirector.querySelector('button');
    if (!select || !button) return;

    select.addEventListener('change', () => {
        button.disabled = false
    });

    button.addEventListener('click', () => {
        const url = select.value;
        if (url) {
            setPopupActivity(popup);
            window.location.href = url;
        }
    });
}

function setPopupActivity(popup) {
    let popupActivity = localStorage.getItem('popupActivity');
    if (!popupActivity) {
        popupActivity = {};
    } else {
        popupActivity = JSON.parse(popupActivity);
    }
    popupActivity[popup.id] = true;

    localStorage.setItem('popupActivity', JSON.stringify(popupActivity));
}

/**
 * Returns true if the should be shown
 * 
 * @param {*} popup 
 */
function shouldShowPopup(popup) {
    let popupActivity = localStorage.getItem('popupActivity');
    if (!popupActivity) return true;
    popupActivity = JSON.parse(popupActivity);
    return !popupActivity[popup.id];
}

document.addEventListener('DOMContentLoaded', initGlobalPopups);